// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1zLLx","title":"InfoRow_title__Y5Wfy"};